import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export default function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    // Scroll to top when pathname changes with smooth behavior
    try {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    } catch (error) {
      // Fallback for browsers that don't support smooth scrolling
      window.scrollTo(0, 0)
    }
  }, [pathname])

  return null
}
